import React, { useState } from 'react';
import PostCard from '../../components/PostCard';
import './index.css';

const Home = () => {
  const [posts] = useState([
    {
      title: "恒星:宇宙的主角",
      date: "2025-12-8",
      tags: ["宇宙", "恒星"],
      excerpt: "纵观宇宙，我找到了属于她的主角。"
    },
    {
      title: "两颗恒星的十万年",
      date: "2025-12-19",
      tags: ["宇宙", "恒星", "光年"],
      excerpt: "一起相伴的两颗恒星，跨越光年。"
    }
  ]);

  return (
    <div className="home">
      <section className="hero">
        <h2>欢迎来到 <span className="purple-star">Starrr</span> 的星空博客</h2>
        <p>在这里，我用代码编织梦想，用文字记录成长。</p>
      </section>

      <section className="recent-posts">
        <h3><span className="purple-star">★</span> 最新文章</h3>
        {posts.map((post, idx) => (
          <PostCard key={idx} {...post} />
        ))}
      </section>
    </div>
  );
};

export default Home;